import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";

export default function PrivacyPolicyPage() {
  const { slug } = useParams();
  const location = useLocation();

  const footerConfig = location.state?.footerConfig || {};

  const title = footerConfig.privacyTitle || "Privacy Policy";
  const content =
    footerConfig.privacyContent ||
    `This privacy policy explains how we collect, use, and protect your information.

We may collect contact information you provide through forms, phone, email, or other interactions.

We use your information only to communicate with you, provide our services, and improve the user experience.

We do not sell your personal information to third parties.

If you have any questions about this privacy policy, please contact us.`;

  const backLink = slug ? `/${slug}` : "/";

  return (
    <div className="min-h-screen bg-white px-4 py-10">
      <div className="max-w-4xl mx-auto">
        <Link
          to={backLink}
          className="inline-block mb-6 text-sm text-blue-600 hover:underline"
        >
          ← Back
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-6">{title}</h1>

        <div className="text-gray-700 leading-7 whitespace-pre-line">
          {content}
        </div>
      </div>
    </div>
  );
}